import React from "react";
import { useDispatch } from "react-redux";
import UnAuthorizedImg from "../Assets/images/Unauthorized.svg";
import { authChange } from "../Reducer/componentSlice";
import { deleteAllCookies, reloadWindow } from "../Helpers/Utils";

const UnAuthorized = () => {
    const dispatch = useDispatch();

    const handleLoginRedirect = () => {
        deleteAllCookies();
        dispatch(authChange(false));
        reloadWindow();
    };

    return (
        <div className="container text-center py-5">
            <img src={UnAuthorizedImg} alt="Unauthorized access" className="img-fluid mb-4" style={{ maxHeight: "300px" }} />
            <h1>401 - Unauthorized</h1>
            <p className="mb-4">Your session has expired or you don't have permission to be here.</p>
            <button className="btn btn-primary px-4" onClick={handleLoginRedirect}>
                Return to Login
            </button>
        </div>
    );
};

export default UnAuthorized;
